<template>
    <div class="video_view">
        <div class="content">
            <cl-no-data v-if="list.length === 0 && !loading" img-type="video" />
            <div class="list-box" v-if="list.length > 0">
                <div class="item" v-for="itemVideo in list" :key="itemVideo.id" @click="clickFun(itemVideo)">
                    <div class="img_box">
                        <img class="img" :src="itemVideo.snapshot" />
                        <div class="foot">
                            <img class="avatar" :src="itemVideo.user_avatar" />
                        </div>
                        <!-- <div class="img_option">
                            <div class="total AkrobatR">
                                <cl-svg-icon icon-class="play_total" />{{ itemVideo.clipCount }}
                            </div>
                        </div> -->
                    </div>
                    <div class="info">
                        <div class="name">{{ itemVideo.name }}</div>
                        <p class="time AkrobatR">{{ $moment(itemVideo.createTime).format('YYYY/MM/DD HH:mm:ss') }}</p>
                    </div>
                    <div class="line"></div>
                </div>
            </div>
        </div>
        <cl-video-clips
            :visible.sync="videoVisible"
            :download="true"
            :title="currentVideo[0] ? currentVideo[0].name : ''"
            :videoList="currentVideo"
        ></cl-video-clips>
    </div>
</template>

<script>
export default {
    props: {
        detailsData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            searchVal: '',
            loading: true,
            list: [],
            videoVisible: false,
            currentVideo: [],
            queryData: this.$route.query,
        }
    },

    methods: {
        async getData() {
            const params = {
                tenant_id: this.detailsData.tenant_id
            }
            const { code, data } = await this.$server.getCampVideoList(params, this.detailsData.id)
            this.loading = false
            if (code === 200 && data) {
                this.list = data
            }
        },
        clickFun(item) {
            item.notDowload = true // 主视频禁止下载
            this.currentVideo = [item]
            this.videoVisible = true
        },
    },

    created() {
        this.getData()
    },
}
</script>
<style lang="scss" scoped>
    .video_view {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .option {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 64px;
        padding: 0 24px;
        border-bottom: 2px solid #e9edf3;
        background: #fff;
        border-radius: 6px 6px 0 0;
    }
    .content {
        flex: 1;
        overflow: hidden;
        background: #fff;
        padding: 24px;
        box-sizing: border-box;
        border-radius: 0 0 6px 6px;
        .list-box {
            display: flex;
            flex-flow: wrap;
            justify-items: flex-start;
            justify-content: flex-start;
            align-content: flex-start;
            width: calc(100% + 25px);
            height: 100%;
            padding-top: 16px;
            margin-top: -16px;
            overflow-y: auto;
            .item {
                position: relative;
                margin-bottom: 16px;
                margin-right: 16px;
                width: 210px;
                height: 178px;
                background: #fff;
                border-radius: 6px;
                box-shadow: 0px 8px 28px rgba(236, 236, 255, 0.5);
                &:hover {
                    .delete,
                    .line {
                        opacity: 1;
                    }
                }
                .delete {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    text-align: center;
                    background: #f95c51;
                    border-radius: 4px;
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    color: #ffffff;
                    font-size: 14px;
                    cursor: pointer;
                    z-index: 1;
                    opacity: 0;
                }
                .line {
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    transform: translateX(-50%);
                    width: 180px;
                    height: 3px;
                    border-radius: 6px 6px 0 0;
                    background: $base-color-theme;
                    opacity: 0;
                    transition: opacity 0.5s;
                }
                .img_box {
                    height: 106px;
                    position: relative;
                    &:hover {
                        .img_option {
                            .down {
                                opacity: 1;
                            }
                        }
                    }
                    .img {
                        border-radius: 6px 6px 0 0;
                        width: 100%;
                        height: 106px;
                    }
                    .foot {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 42px;
                        height: 42px;
                        background: url('~@/assets/images/video/jiao.png') no-repeat;
                        background-size: 100% 100%;
                        .avatar {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                        }
                    }
                    .img_option {
                        position: absolute;
                        width: 90px;
                        left: 4px;
                        bottom: 4px;
                        z-index: 1;
                        display: flex;
                        .img_btn {
                            display: flex;
                            align-items: center;
                            height: 22px;
                            cursor: pointer;
                            border-radius: 40px;
                        }
                        .total {
                            @extend .img_btn;
                            padding: 4px 6px;
                            font-size: 14px;
                            box-sizing: border-box;
                            color: #fff;
                            .svg-icon {
                                margin-right: 4px;
                                color: #fff;
                                width: 14px !important;
                                height: 14px !important;
                            }
                        }
                        .down {
                            @extend .img_btn;
                            width: 22px;
                            justify-content: center;
                            margin-left: 8px;
                            opacity: 0;
                            transition: all 0.5s;
                            &:hover {
                                background: $base-color-theme !important;
                            }
                            .svg-icon {
                                color: #fff;
                                width: 16px !important;
                                height: 16px !important;
                            }
                        }
                    }
                }
                .info {
                    padding: 14px 16px;
                    box-sizing: border-box;
                    .name {
                        margin-bottom: 8px;
                        font-size: 16px;
                        color: #3a3a3a;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 100%;
                    }
                    .time {
                        font-size: 14px;
                        color: #b7b7bf;
                    }
                }
            }
        }
    }
</style>
